import { CodedError } from '../../CodedError';
import { errorCodeTypes } from '../errorCodeTypes';

export class InvalidDaysAheadError extends CodedError {
  static get errorName() {
    return errorCodeTypes.invalidDaysAheadError.code;
  }

  constructor(message = errorCodeTypes.invalidDaysAheadError.message) {
    super(message);
    this.code = errorCodeTypes.invalidDaysAheadError.code;
    this.name = errorCodeTypes.invalidDaysAheadError.name;
  }
}
